import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConstants } from "../common/app.constants";
import { Observable } from "rxjs";

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json'})
};
@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    constructor(private http: HttpClient) { }

    addProfile(data: any, update): Observable<any> {
        return this.http.post(AppConstants.API_URL + 'profileUser/add?update=' + update, data, httpOptions);
    }

    getAllProfile(page,size): Observable<any> {
        return this.http.get(AppConstants.API_URL + 'profileUser/all?page=' + page + '&size=' + size , httpOptions);
    }
}